import React, { useContext, useEffect, useRef } from 'react';
import HeaderLayout from './HeaderLayout';
import SidebarLayout from './SidebarLayout';
import MainLayout from './MainLayout';
import FooterLayout from './FooterLayout';
import { useLocation } from 'react-router-dom';
import { SidebarContext } from '../context/Sidebar';

export default function PageLayout({ children }) {
  const { pathname } = useLocation();
  const { sidebar, toggleSidebar } = useContext(SidebarContext);
  const sidebarRef = useRef();
  const toggleButtonRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Kiểm tra xem click có phải là từ toggle button không
      const isToggleButton = toggleButtonRef.current?.contains(event.target);

      if (
        window.matchMedia('(max-width: 991px)').matches &&
        sidebar &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !isToggleButton
      ) {
        toggleSidebar();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [sidebar, toggleSidebar]);

  return (
    <>
      <HeaderLayout toggleButtonRef={toggleButtonRef} />
      <SidebarLayout ref={sidebarRef} />
      <MainLayout>
        <>
          {children}
          {pathname !== '/message'}
        </>
      </MainLayout>
      <FooterLayout />
    </>
  );
}
